import { render } from "./OvArchive.vue?vue&type=template&id=2a7dc318&scoped=true"
import script from "./OvArchive.vue?vue&type=script&lang=js"
export * from "./OvArchive.vue?vue&type=script&lang=js"

import "./OvArchive.vue?vue&type=style&index=0&id=2a7dc318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7dc318"],['__file',"src/views/overlatelser/OvArchive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a7dc318"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a7dc318', __exports__)) {
    api.reload('2a7dc318', __exports__)
  }
  
  module.hot.accept("./OvArchive.vue?vue&type=template&id=2a7dc318&scoped=true", () => {
    api.rerender('2a7dc318', render)
  })

}


export default __exports__